/* Nítido · JS propio (v18, 10 oct 2026). Antes iba en línea en los bloques "Liquid personalizado" del producto y la home
   (contador de corte, galería automática, selector de 2 tarjetas, video y botones repetidos), en la cinta (sections/nv-ticker.liquid)
   y en el encabezado (snippets/nv-header-extras.liquid). Se carga con defer desde layout/theme.liquid (igual que en v14). */

/* 1) Encabezado: "VER PRECIO" baja suave a "ELIGE TU OFERTA" */
(function () {
  if (window.__nvScroll) return; window.__nvScroll = true;
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[data-nv-scroll]');
    if (!a) return;
    var href = a.getAttribute('href') || '', i = href.indexOf('#');
    if (i < 0) return;
    var el = document.getElementById(href.slice(i + 1));
    if (!el) return;
    e.preventDefault();
    el.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
  });
})();

/* 2) Cinta de anuncios: se detiene al tocarla (antes usaba document.currentScript; ahora busca cada .nv-ticker) */
(function () {
  document.querySelectorAll('.nv-ticker').forEach(function (el) {
    if (el.__nt) return; el.__nt = true;
    el.addEventListener('click', function () { el.classList.toggle('is-paused'); });
  });
})();

/* 3) Galería (velocidad): al inicio solo baja la primera foto (las demás tienen loading="lazy").
   Las demás se piden 1 s después de que la primera cargó, al terminar de cargar la página o antes de que la galería avance sola. */
(function () {
  var imgs = [].slice.call(document.querySelectorAll('media-gallery slideshow-slide img.product-media__image'));
  if (imgs.length < 2) return;
  var done = false;
  function warm() { if (done) return; done = true; imgs.forEach(function (im) { if (im.loading === 'lazy') im.loading = 'eager'; }); }
  window.nitidoWarmGallery = warm;
  var first = imgs[0];
  if (first.complete && first.naturalWidth) { setTimeout(warm, 1000); }
  else { first.addEventListener('load', function () { setTimeout(warm, 1000); }, { once: true }); }
  window.addEventListener('load', warm, { once: true });
})();

/* 4) y 5) Contador de corte (APAGADO) y galería automática: solo donde está el bloque (producto y home) */
if (document.querySelector('.nv-corte-js')) {
/* Contador de hora de corte de despacho (Colombia, UTC-5). APAGADO hasta tener la hora real del proveedor.
   Para prenderlo: activo:true y hora:"HH:MM" (hora de Colombia). dias_sin_despacho: 0=domingo ... 6=sábado.
   Mientras está prendido reemplaza la barra de anuncios (para no empujar el botón) y sale también en el aviso del popup. */
window.NITIDO_CORTE = window.NITIDO_CORTE || {
  activo: false,
  hora: "",
  dias_sin_despacho: [],
  texto_hoy: "PIDE EN LAS PRÓXIMAS {t} Y SALE HOY",
  texto_manana: "PIDE EN LAS PRÓXIMAS {t} Y SALE MAÑANA",
  texto_dia: "PIDE EN LAS PRÓXIMAS {t} Y SALE EL {dia}"
};
(function(){
  if(window.nitidoCorte) return;
  var DIAS=['DOMINGO','LUNES','MARTES','MIÉRCOLES','JUEVES','VIERNES','SÁBADO'];
  var OFF=5*3600000; /* Colombia = UTC-5, sin horario de verano */
  function cfg(){ return window.__nitidoCorteTest || window.NITIDO_CORTE || {}; }
  function valid(c){ return c && c.activo && /^([01]?\d|2[0-3]):[0-5]\d$/.test(c.hora||''); }
  function next(c){
    var now=Date.now(); var hm=c.hora.split(':'); var H=+hm[0], M=+hm[1]; var skip=c.dias_sin_despacho||[];
    var co=new Date(now-OFF); var y=co.getUTCFullYear(), m=co.getUTCMonth(), d=co.getUTCDate();
    for(var i=0;i<8;i++){ var t=Date.UTC(y,m,d+i,H,M)+OFF; var dow=new Date(t-OFF).getUTCDay(); if(t>now && skip.indexOf(dow)<0){ return {t:t, dias:i, dow:dow}; } }
    return null;
  }
  function parts(ms){ var s=Math.max(0,Math.floor(ms/1000)); var h=Math.floor(s/3600), mi=Math.floor(s%3600/60), se=s%60; function p(n){ return (n<10?'0':'')+n; } return [p(h),p(mi),p(se)]; }
  function text(c,n){ var tpl = n.dias===0 ? c.texto_hoy : (n.dias===1 ? c.texto_manana : c.texto_dia); return (tpl||'').replace('{dia}', DIAS[n.dow]); }
  var bar=null, timer=null;
  function render(){
    var c=cfg(); if(!valid(c)){ stop(); return; }
    var n=next(c); if(!n){ stop(); return; }
    var p=parts(n.t-Date.now()); var tx=text(c,n).split('{t}');
    if(!bar){
      bar=document.createElement('div'); bar.className='nv-corte'; bar.setAttribute('role','timer');
      var ann=document.querySelector('[id*="header_announcements"]'); if(ann){ ann.style.display='none'; ann.parentNode.insertBefore(bar, ann); } else { document.body.insertBefore(bar, document.body.firstChild); }
    }
    bar.innerHTML='<span class="nc-t">'+(tx[0]||'').trim()+'</span><span class="nc-bs"><span class="nc-b"><b>'+p[0]+'</b><i>H</i></span><span class="nc-b"><b>'+p[1]+'</b><i>MIN</i></span><span class="nc-b"><b>'+p[2]+'</b><i>SEG</i></span></span><span class="nc-t">'+(tx[1]||'').trim()+'</span>';
    window.dispatchEvent(new CustomEvent('nitido:corte'));
  }
  function stop(){ if(timer){ clearInterval(timer); timer=null; } if(bar){ bar.remove(); bar=null; var ann=document.querySelector('[id*="header_announcements"]'); if(ann) ann.style.display=''; } }
  function start(){ stop(); if(!valid(cfg())) return; render(); timer=setInterval(render,1000); }
  /* Texto corto para el aviso del popup (null si está apagado) */
  function line(){ var c=cfg(); if(!valid(c)) return null; var n=next(c); if(!n) return null; var p=parts(n.t-Date.now()); var t=text(c,n).replace('{t}', p.join(':')); return t.charAt(0)+t.slice(1).toLowerCase(); }
  window.nitidoCorte={start:start, stop:stop, line:line};
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
/* 1c) Galería: avanza sola cada 3,5 s y se detiene para siempre cuando el cliente la toca. Apagada con "reducir movimiento". */
(function(){
  if(window.__nvGal) return; window.__nvGal=true;
  var reduce=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
  function init(){
    if(reduce) return;
    document.querySelectorAll('media-gallery slideshow-component').forEach(function(ss){
      if(ss.__nvAuto) return; ss.__nvAuto=true;
      var stopped=false, inView=true, t=null;
      function stop(){ stopped=true; if(t){ clearInterval(t); t=null; } }
      var mg=ss.closest('media-gallery')||ss;
      ['pointerdown','touchstart','wheel','keydown'].forEach(function(ev){ mg.addEventListener(ev, stop, {passive:true}); });
      if('IntersectionObserver' in window){ new IntersectionObserver(function(es){ inView=es[0].isIntersecting; }).observe(ss); }
      t=setInterval(function(){ if(stopped||document.hidden||!inView) return; if(ss.querySelector('.pc-hero')&&performance.now()<9000) return; var d=document.getElementById('rsi_form_wrapper'); if(d&&getComputedStyle(d).display!=='none'&&d.querySelector('form')&&d.getBoundingClientRect().height>0) return; if(window.nitidoWarmGallery) window.nitidoWarmGallery(); try{ ss.next(); }catch(e){} }, 3500);
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
}

/* 6) Selector de 2 tarjetas + ajustes del popup de Releasit (1-Tick del repuesto solo con 1 filtro): solo donde está el selector */
if (document.getElementById('elige-tu-oferta')) {
(function(){
  if(window.__nitidoSelInit) return; window.__nitidoSelInit=true;
  var first=document.querySelector('.nv-card.is-active');
  window.nitidoSel = window.nitidoSel || (first ? first.getAttribute('data-nitido-opt') : 'dos');
  var viaCard = null;
  function cards(){ return document.querySelectorAll('.nv-card'); }
  function paint(){ cards().forEach(function(c){ var on=c.getAttribute('data-nitido-opt')===window.nitidoSel; c.classList.toggle('is-active',on); c.setAttribute('aria-checked',on?'true':'false'); }); }
  function visibleBtn(){ return [].slice.call(document.querySelectorAll('#rsi_buy_now_button')).filter(function(x){return x.offsetParent;})[0]; }
  function wrap(){ return document.getElementById('rsi_form_wrapper'); }
  function offers(){ var d=wrap(); return d?d.querySelectorAll('input[name="quantity_offer"]'):[]; }
  /* Índice de la oferta marcada en Releasit (0 = 1 filtro, 1 = 2 filtros). -1 si no hay oferta de cantidad. */
  function tier(){ var r=offers(); for(var i=0;i<r.length;i++){ if(r[i].checked) return i; } return r.length?0:-1; }
  /* 1-Tick del repuesto: visible solo con 1 filtro; con 2 se desmarca y se esconde. */
  /* Caja del 1-Tick en Releasit (5 oct): input.rsi-onetick-checkbox dentro de div.rsi-onetick-wrapper (con el texto y la foto).
     Se esconde la envoltura, no solo la casilla; si su padre solo la contiene a ella, se esconde el padre (sin hueco). */
  function oneTickBox(cb){ var p=cb.parentElement; var w=(p&&p.closest('.rsi-onetick-wrapper, [class*="onetick-wrapper"], .rsi-onetick'))||p;
    if(w && w.parentElement && w.parentElement.childElementCount===1 && !/rsi-layout-wrapper|rsi-form/.test(w.parentElement.className||'')) w=w.parentElement;
    return w; }
  function syncOneTick(){ var d=wrap(); if(!d) return; var t=tier(); var two=(t>=1);
    d.querySelectorAll('input.rsi-onetick-checkbox').forEach(function(cb){ var box=oneTickBox(cb);
      if(two){ if(cb.checked){ cb.click(); } if(box && box.style.display!=='none'){ box.style.display='none'; box.setAttribute('data-nv-hidden','1'); } }
      else if(box && box.getAttribute('data-nv-hidden')==='1'){ box.style.display=''; box.removeAttribute('data-nv-hidden'); } }); }
  window.nitidoSyncOneTick = syncOneTick;
  /* Marca en Releasit la oferta de la tarjeta (dos = 2.ª, uno = 1.ª). Sin oferta de cantidad no toca nada. */
  function apply(src, tries){ tries=tries||0; var d=wrap(); var r=offers();
    if(!d||!r||!r.length){ if(tries<16) return setTimeout(function(){apply(src,tries+1);},250); return; }
    var want=(src==='dos'&&r.length>1)?1:0; if(!r[want].checked){ r[want].click(); } setTimeout(function(){ note(); syncOneTick(); },90); setTimeout(syncOneTick,400);
    if(want===1){ setTimeout(function(){ fixQty(0); },800); } }
  /* 10 oct: a veces Releasit abre con «2 filtros» marcado pero la línea queda en 1 y cobra 1 filtro (pasaba desde la home).
     Si pasa, se elige «1 filtro» y luego otra vez «2 filtros» (Releasit tarda ~1,2 s en aplicar cada clic). No actúa si la persona ya tocó una opción. */
  var nvUserPick=0;
  document.addEventListener('click',function(e){ if(e.isTrusted && e.target && e.target.closest && e.target.closest('#rsi_form_wrapper .rsi-quantity-product, #rsi_form_wrapper input[name="quantity_offer"]')) nvUserPick=Date.now(); }, true);
  function qtyShown(){ var d=wrap(); var q=d&&d.querySelector('.rsi-product-item-quantity'); var n=q?parseInt((q.textContent||'').trim(),10):NaN; return isNaN(n)?null:n; }
  function waitFor(cond, ms, cb){ var t0=Date.now(); (function loop(){ if(cond()) return cb(true); if(Date.now()-t0>ms) return cb(false); setTimeout(loop,150); })(); }
  function fixQty(tries){ var r=offers(); if(!r||r.length<2||tries>1||!r[1].checked) return; var q=qtyShown(); if(q===null||q>=2) return;
    var t0=Date.now(); if(t0-nvUserPick<4000) return;
    r[0].click();
    waitFor(function(){ var r2=offers(); return r2.length>1 && r2[0].checked && qtyShown()===1; }, 4000, function(){
      setTimeout(function(){ if(nvUserPick>t0) return; var r3=offers(); if(r3.length>1 && !r3[1].checked) r3[1].click();
        waitFor(function(){ var r4=offers(); return r4.length>1 && r4[1].checked && qtyShown()===2; }, 4000, function(){ syncOneTick(); setTimeout(function(){ fixQty(tries+1); },300); }); },350); }); }
  var TXT='💵 Pagas al recibir · 🚚 Envío gratis';
  function note(){ var d=wrap(); if(!d) return;
    var host=d.querySelector('._rsi-modal-body, .rsi-modal-body, form')||d; var n=d.querySelector('.nv-popnote');
    if(!n){ n=document.createElement('div'); n.className='nv-popnote'; n.setAttribute('role','status'); host.insertBefore(n, host.firstChild); }
    var line=(window.nitidoCorte&&window.nitidoCorte.line)?window.nitidoCorte.line():null;
    var html='<span class="npn-main">'+TXT+'</span>'+(line?'<span class="npn-corte">⏱ '+line+'</span>':'');
    if(n.__h!==html){ n.innerHTML=html; n.__h=html; } }
  window.addEventListener('nitido:corte',note);
  setInterval(function(){ var d=wrap(); if(d && getComputedStyle(d).display!=='none'){ note(); syncOneTick(); } },500);
  document.addEventListener('change',function(e){ if(e.target && e.target.name==='quantity_offer'){ setTimeout(syncOneTick,60); setTimeout(syncOneTick,300); } }, true);
  window.nitidoOpen=function(sel){ if(sel){ window.nitidoSel=sel; paint(); } var src=window.nitidoSel; var b=visibleBtn(); if(b){ viaCard=src; b.click(); viaCard=null; setTimeout(function(){apply(src);},400); } else { var t=document.querySelector('.buy-buttons-block'); if(t) t.scrollIntoView({behavior:'smooth',block:'center'}); } };
  document.addEventListener('click',function(e){ var c=e.target.closest&&e.target.closest('.nv-card'); if(c){ window.nitidoOpen(c.getAttribute('data-nitido-opt')); return; }
    var b=e.target.closest&&e.target.closest('#rsi_buy_now_button'); if(b && !viaCard){ setTimeout(function(){apply(window.nitidoSel);},400); }
    var q=e.target.closest&&e.target.closest('[data-nv-open]'); if(q){ e.preventDefault(); window.nitidoOpen(q.getAttribute('data-nv-open')); } }, true);
  paint();
})();
}

/* 7) Video "Míralo instalado": se carga y suena solo cuando está cerca de la pantalla; el póster también se pide tarde */
(function () {
  document.querySelectorAll('.nv-demo-v').forEach(function (v) {
    if (v.__nv) return; v.__nv = 1;
    function poster() { var p = v.getAttribute('data-poster'); if (p && !v.getAttribute('poster')) v.setAttribute('poster', p); }
    function go() {
      if (v.src) return; poster();
      var sd = (navigator.connection && /2g|3g/.test(navigator.connection.effectiveType || ''));
      v.src = sd ? v.getAttribute('data-src-sd') : v.getAttribute('data-src');
      var p = v.play(); if (p && p.catch) p.catch(function () {});
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (e, o) { if (e[0].isIntersecting) { poster(); o.disconnect(); } }, { rootMargin: '900px' }).observe(v);
      var io = new IntersectionObserver(function (e) {
        e.forEach(function (x) {
          if (x.isIntersecting) { go(); } else if (v.src && !v.paused) { v.pause(); }
          if (x.isIntersecting && v.src && v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        });
      }, { rootMargin: '200px' });
      io.observe(v);
    } else { go(); }
  });
})();

/* 8) Botones repetidos ("PEDIR Y PAGAR AL RECIBIR", "Quiero mi filtro") en páginas sin selector (con selector los maneja el punto 6) */
if (!document.getElementById('elige-tu-oferta')) {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-nv-open]');
    if (!btn) return;
    if (window.nitidoOpen) { window.nitidoOpen(); return; }
    var b = [].slice.call(document.querySelectorAll('#rsi_buy_now_button')).filter(function (x) { return x.offsetParent; });
    if (b.length) { b[0].click(); } else { var t = document.querySelector('.buy-buttons-block'); if (t) { t.scrollIntoView({ behavior: 'smooth', block: 'center' }); } }
  });
}
